// Persistent error banner for the data-layer boundary. Renders the
// current `usePersistenceError()` value when non-null; renders nothing
// otherwise. Per spec/build-plan.md P-021 row + spec/tech-arch.md §5.3.
//
// **V1 stub-level styling.** Tailwind utilities for a top-of-screen
// colored bar with text. P-035 polish (and Banks's review against the
// PSD source) refines the visual treatment. The role="alert" landmark
// is the load-bearing accessibility hook — screen readers announce
// the banner content when it appears, which is the right behavior for
// a persistent failure surface (the user can't dismiss; they need to
// know about it). Polite announce vs assertive: alert role is
// assertive; persistence failures are urgent enough to interrupt.
//
// **No app-shell integration yet.** P-022 (app shell rebuild) wires
// this component into the top-level layout. P-021 ships the component
// file alone; tests use direct render-to-container per the
// `useStore` test infrastructure.

import { usePersistenceError } from '../store/persistence'

export function PersistenceBanner() {
  const error = usePersistenceError()
  if (error === null) return null
  return (
    <div
      role="alert"
      class="bg-red-100 text-red-900 border-b border-red-300 px-4 py-2 text-sm"
    >
      {error}
    </div>
  )
}
